<template>
  <section id="archive" class="spacer">
    <div class="big title">{{ archive.title }}</div>
    <div v-for="item in archive.items" :key="item.year" class="year big pt">
      <a target="_blank" :href="item.link">{{ item.year }}</a>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      archive: []
    };
  },
  created() {
    API.archive(this.$i18n.locale).then(page => {
      this.archive = page.data.result;
    });
  }
};
</script>

<style lang="scss" scoped>
.year {
  padding-bottom: var(--lh);
  border-bottom: var(--b) solid var(--color);
  &:last-of-type {
    padding-bottom: 0;
    border-bottom: 0;
  }
}
</style>
